export default {
  methods: {
    dev_env() {
      return process.env.NODE_ENV === 'development'
    }
  }
}
